import React from 'react';
import Modal from '../Modal';
import { Remorque } from '../../types';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface DeleteTrailerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  trailer: Remorque;
}

const DeleteTrailerModal: React.FC<DeleteTrailerModalProps> = ({ isOpen, onClose, onConfirm, trailer }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirmer la suppression" size="md">
      <div className="space-y-6">
        {/* Icône d'avertissement */}
        <div className="flex justify-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
            <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
          </div>
        </div>

        {/* Message de confirmation */}
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Supprimer cette remorque ?
          </h3>
          <p className="text-sm text-gray-500">
            Êtes-vous sûr de vouloir supprimer la remorque{' '}
            <span className="font-medium text-gray-900">
              {trailer.immatriculation}
            </span>{' '}
            ({trailer.marque} {trailer.modele}) ?
          </p>
          <p className="text-sm text-red-600 mt-2">
            Cette action est irréversible et supprimera définitivement la remorque.
          </p>
        </div>

        {/* Informations de la remorque */}
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="font-medium text-gray-700">Immatriculation:</span>
              <p className="text-gray-900">{trailer.immatriculation}</p>
            </div>
            <div>
              <span className="font-medium text-gray-700">Marque:</span>
              <p className="text-gray-900">{trailer.marque}</p>
            </div>
            <div>
              <span className="font-medium text-gray-700">Modèle:</span>
              <p className="text-gray-900">{trailer.modele}</p>
            </div>
            <div>
              <span className="font-medium text-gray-700">Propriétaire:</span>
              <p className="text-gray-900">{trailer.proprietaire}</p>
            </div>
            <div>
              <span className="font-medium text-gray-700">Capacité:</span>
              <p className="text-gray-900">{trailer.capacite} kg</p>
            </div>
            <div>
              <span className="font-medium text-gray-700">Dimensions:</span>
              <p className="text-gray-900">{trailer.longueur} × {trailer.largeur} × {trailer.hauteur} m</p>
            </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
          >
            Supprimer
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTrailerModal;
